export default __webpack_public_path__ + "static/media/card-bg.a08d0d10.jpeg";